var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import Map, { Marker } from 'react-map-gl';
import { SearchBox } from '@mapbox/search-js-react';
import { JsonEditor as Editor } from 'jsoneditor-react';
import 'jsoneditor-react/es/editor.min.css';
import RTEditor from '@project/components/Forms/Fields/RTEditor';
import MediaInput from '@project/components/Forms/Fields/MediaInput';
import toast from '../Toast';
import { formatColumnType } from '../FilterDataset/helpers';
import { isValidURL } from '../../utils';
import Pin from '../Map/Pin';
import DatePicker from '../Forms/Fields/DatePicker';
import { Checkbox, Input } from '../Forms/Fields';
import { AddButton, ContainerWrapper, IconWrapper, Item, ItemSubText, ItemText, ItemWrapper, JsonBuilderWrapper, LabelWrapper, UrlValidationMessage, } from './styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSlidersV } from '@fortawesome/pro-regular-svg-icons/faSlidersV';
import { faPlus } from '@fortawesome/pro-regular-svg-icons/faPlus';
import { faTrash } from '@fortawesome/pro-solid-svg-icons/faTrash';
var DEFAULT_VIEWPORT = {
    latitude: 57.698329,
    longitude: 11.9860685,
    zoom: 10,
    bearing: 0,
    pitch: 0,
};
var DEFAULT_LOCATION = {
    lat: 57.698329,
    lon: 11.9860685,
};
var InputRenderer = function (_a) {
    var _b, _c, _d, _e, _f;
    var field = _a.field, sendObject = _a.sendObject, setSendObject = _a.setSendObject, _g = _a.files, files = _g === void 0 ? [] : _g, _h = _a.disabled, disabled = _h === void 0 ? false : _h, _j = _a.placeholder, placeholder = _j === void 0 ? '' : _j, _k = _a.checkNull, checkNull = _k === void 0 ? false : _k, _l = _a.setCheckNull, setCheckNull = _l === void 0 ? function () { } : _l, _m = _a.appCreationAppId, appCreationAppId = _m === void 0 ? '' : _m, _o = _a.fullWidth, fullWidth = _o === void 0 ? false : _o, _p = _a.setIsNumberEmpty, setIsNumberEmpty = _p === void 0 ? function (arg) { } : _p, _q = _a.template, template = _q === void 0 ? false : _q;
    var _r = useState([{ id: 1, builder: false }]), builderData = _r[0], setBuilderData = _r[1];
    var _s = useState(1), itemNumber = _s[0], setItemNumber = _s[1];
    var _t = useState(false), isUrlInvalid = _t[0], setIsUrlInvalid = _t[1];
    var viewportData = (sendObject[field.name] && {
        latitude: ((_b = sendObject[field.name]) === null || _b === void 0 ? void 0 : _b.lat) || 57.698329,
        longitude: ((_c = sendObject[field.name]) === null || _c === void 0 ? void 0 : _c.lon) || 11.9860685,
        zoom: 10,
        bearing: 0,
        pitch: 0,
    }) ||
        DEFAULT_VIEWPORT;
    var filedName = sendObject[field.name];
    useEffect(function () {
        if (field.type === 'list' && filedName && Array.isArray(filedName)) {
            setBuilderData(filedName);
            setItemNumber(filedName.length);
        }
    }, [filedName, field.name, field.type]);
    useEffect(function () {
        if (field.type === 'list' && checkNull) {
            setBuilderData([]);
            setItemNumber(0);
        }
    }, [checkNull, field === null || field === void 0 ? void 0 : field.type]);
    var changeOpen = function (bId) {
        builderData.forEach(function (element, index) {
            if (element.id === bId) {
                builderData[index].builder = !element.builder;
            }
        });
        setBuilderData(__spreadArray([], builderData, true));
    };
    var removeBuilder = function (bId) {
        var removeBuilder = builderData.filter(function (item) { return item.id !== bId; });
        setBuilderData(__spreadArray([], removeBuilder, true));
    };
    var onChange = function (e) {
        var _a;
        var target = e.target;
        var _b = e.target, value = _b.value, type = _b.type, name = _b.name;
        var newVal = value;
        switch (type) {
            case 'checkbox':
                newVal = target.checked;
                break;
            case 'number':
                newVal = Number(value);
                if (Number.isNaN(newVal)) {
                    toast.error('Value must be a number');
                    return;
                }
                break;
            case 'url':
                if (value === '') {
                    setIsUrlInvalid(true);
                }
                else if (value && !isValidURL(value)) {
                    setIsUrlInvalid(true);
                    return;
                }
                else {
                    setIsUrlInvalid(false);
                }
                break;
            default:
                break;
        }
        setSendObject(__assign(__assign({}, sendObject), (_a = {}, _a[name] = newVal, _a)));
        if (checkNull) {
            setCheckNull(false);
        }
    };
    var updateViewport = function (viewport, fieldName) {
        var _a;
        setSendObject(__assign(__assign({}, sendObject), (_a = {}, _a[fieldName] = __assign(__assign({}, sendObject[fieldName]), { viewport: viewport }), _a)));
    };
    var updateLocation = function (viewport, fieldName) {
        var _a;
        setSendObject(__assign(__assign({}, sendObject), (_a = {}, _a[fieldName] = __assign(__assign({}, sendObject[fieldName]), { viewport: viewport, lon: viewport.longitude, lat: viewport.latitude }), _a)));
    };
    var onMarkerDrag = function (e, fieldName) {
        var _a;
        setSendObject(__assign(__assign({}, sendObject), (_a = {}, _a[fieldName] = __assign(__assign({}, sendObject[fieldName]), { lon: e.lngLat.lng, lat: e.lngLat.lat }), _a)));
    };
    var onClickMap = function (e) {
        var _a;
        var _b = e.lngLat, lng = _b.lng, lat = _b.lat;
        setSendObject(__assign(__assign({}, sendObject), (_a = {}, _a[field.name] = __assign(__assign({}, sendObject[field.name]), { lon: lng, lat: lat }), _a)));
    };
    var handleDateChange = function (timestamp, fieldName) {
        var _a;
        setSendObject(__assign(__assign({}, sendObject), (_a = {}, _a[fieldName] = timestamp, _a)));
    };
    var onChangeMultipleJson = function (data, id, fieldName) {
        var _a;
        builderData.forEach(function (element, index) {
            if (element.id === id) {
                builderData[index][fieldName] = data;
            }
        });
        setBuilderData(__spreadArray([], builderData, true));
        setSendObject((_a = {},
            _a[fieldName] = builderData,
            _a));
        if (checkNull) {
            setCheckNull(false);
        }
    };
    var onChangeJson = function (data, name) {
        var _a;
        setSendObject(__assign(__assign({}, sendObject), (_a = {}, _a[name] = JSON.stringify(data), _a)));
        if (checkNull) {
            setCheckNull(false);
        }
    };
    switch (field.type) {
        case 'richtext':
            return (_jsx(RTEditor, { style: { margin: '0.7rem 0 0.5rem' }, value: sendObject[field.name], onChange: function (value) { return onChange({ target: { value: value, name: field.name } }); }, disabled: disabled }));
        case 'boolean':
            return (_jsx(Checkbox, { style: { flex: '0', margin: '20px 0' }, name: field.name, checked: sendObject[field.name], type: "checkbox", onChange: onChange, disabled: disabled }));
        case 'time':
        case 'timestamp':
            return (_jsx(DatePicker, { style: { marginTop: '11px' }, date: sendObject[field.name] && new Date(sendObject[field.name]), onChange: function (timestamp) {
                    handleDateChange(new Date(timestamp).toISOString(), field.name);
                }, disabled: disabled, autoWidth: fullWidth }));
        case 'location':
            return (_jsx("div", __assign({ style: { height: 'auto' } }, { children: _jsxs(Map, __assign({}, viewportData, { latitude: viewportData.latitude, longitude: viewportData.longitude, zoom: viewportData.zoom, onClick: onClickMap, style: {
                        position: 'relative',
                        marginTop: '0.7rem',
                        marginBottom: '0.5rem',
                        width: '100%',
                        height: '350px',
                    }, mapStyle: "mapbox://styles/mapbox/streets-v11", mapboxAccessToken: process.env.MAPBOX_API_TOKEN }, { children: [_jsx("div", __assign({ style: {
                                position: 'absolute',
                                top: '12px',
                                left: '50%',
                                transform: 'translateX(-50%)',
                                width: '50%',
                                maxWidth: '500px',
                                zIndex: 10,
                            } }, { children: _jsx(SearchBox, { accessToken: "".concat(process.env.MAPBOX_API_TOKEN), placeholder: "Search location...", onRetrieve: function (res) {
                                    var _a;
                                    var feature = (_a = res.features) === null || _a === void 0 ? void 0 : _a[0];
                                    if (!feature)
                                        return;
                                    var _b = feature.geometry.coordinates, lon = _b[0], lat = _b[1];
                                    updateLocation({
                                        latitude: lat,
                                        longitude: lon,
                                        zoom: 14,
                                    }, field.name);
                                } }) })), _jsx(Marker, __assign({ latitude: (sendObject[field.name] && sendObject[field.name].lat) ||
                                DEFAULT_LOCATION.lat, longitude: (sendObject[field.name] && sendObject[field.name].lon) ||
                                DEFAULT_LOCATION.lon, offset: [-10, -20], disabled: disabled, draggable: true, onDrag: function (e) { return onMarkerDrag(e, field.name); } }, { children: _jsx(Pin, { size: 20 }) }))] })) })));
        case 'image':
            return (_jsx(MediaInput, { selectedFile: sendObject[field.name] &&
                    ((_d = Object.keys(sendObject[field.name])) === null || _d === void 0 ? void 0 : _d.length) === 0
                    ? ''
                    : sendObject[field.name], onSelectFile: function (value) {
                    onChange({ target: { value: value.url, name: field.name } });
                }, type: "image", files: files, disabled: disabled, appId: appCreationAppId, fullWidth: fullWidth }));
        case 'file':
            return (_jsx(MediaInput, { selectedFile: sendObject[field.name] &&
                    ((_e = Object.keys(sendObject[field.name])) === null || _e === void 0 ? void 0 : _e.length) === 0
                    ? ''
                    : sendObject[field.name], onSelectFile: function (value) {
                    return onChange({ target: { value: value.url, name: field.name } });
                }, type: "file", files: files, disabled: disabled, appId: appCreationAppId, fullWidth: fullWidth }));
        case 'json':
            return (_jsx(Editor, { value: sendObject[field.name] || {}, onChange: function (data) { return onChangeJson(data, field.name); } }, checkNull ? sendObject[field.name] : {}));
        case 'list':
            return (_jsx(_Fragment, { children: !disabled && (_jsxs(ContainerWrapper, { children: [builderData === null || builderData === void 0 ? void 0 : builderData.map(function (item) { return (_jsxs(ItemWrapper, { children: [_jsx(IconWrapper, { children: _jsx(FontAwesomeIcon, { icon: faSlidersV }) }), _jsxs(Item, { children: [_jsxs(LabelWrapper, { children: [_jsxs(ItemText, __assign({ onClick: function () {
                                                        changeOpen(item.id);
                                                    } }, { children: ["Item ", item.id, " ", _jsx(ItemSubText, { children: "(json)" })] })), _jsx(FontAwesomeIcon, { icon: faTrash, onClick: function () {
                                                        removeBuilder(item.id);
                                                    } })] }), item.builder && (_jsx(JsonBuilderWrapper, { children: _jsx(Editor, { value: item[field.name] || {}, onChange: function (data) {
                                                    return onChangeMultipleJson(data, item.id, field.name);
                                                } }) }))] })] }, item.id)); }), _jsxs(AddButton, __assign({ onClick: function () {
                                setBuilderData(__spreadArray(__spreadArray([], builderData, true), [
                                    { id: itemNumber + 1, builder: false },
                                ], false));
                                setItemNumber(itemNumber + 1);
                            } }, { children: [_jsx(FontAwesomeIcon, { color: "#252525", icon: faPlus }), " \u00A0Add Item"] }))] })) }));
        default:
            return (_jsxs(_Fragment, { children: [_jsx(Input, { type: field.type ? formatColumnType(field.type) : 'text', defaultValue: (field.type === 'text' || field.type === 'url') &&
                            sendObject[field.name] &&
                            ((_f = Object.keys(sendObject[field.name])) === null || _f === void 0 ? void 0 : _f.length) === 0
                            ? ''
                            : sendObject[field.name], name: field.name, template: template, onInput: onChange, onChange: function (e) {
                            if (appCreationAppId !== '' && field.type === 'number') {
                                e.target.value.length === 0
                                    ? setIsNumberEmpty(true)
                                    : setIsNumberEmpty(false);
                            }
                        }, disabled: disabled, placeholder: placeholder, setNull: checkNull }), field.type === 'url' && isUrlInvalid && (_jsx(UrlValidationMessage, { children: "Value must be a valid URL" }))] }));
    }
};
export default InputRenderer;
